export const ROLE_PERMISSION_LINK =
	'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-roles/';

export const WHAT_ARE_OBJECT_TYPES_LINK =
	'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-object-types/';
